import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icon/search.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
::before,
::after {
  box-sizing: border-box;
}

dialog {
  padding: 0;
  overscroll-behavior: contain;
  border: 0;
}

@media (width > 1044px) {

dialog {
    width: calc(var(--layout-content-max) + 1rem);
    max-height: calc(100% - var(--sticky-header-height) - 2rem);

    margin: calc(var(--sticky-header-height) + 1rem) auto 1rem;

    font-size: var(--font-size-large);

    background-color: var(--color-background-primary);
    border: 1px solid var(--color-border-primary);
    border-radius: 0.5rem;
}

    dialog::backdrop {
      --csstools-light-dark-toggle-177de763-0: var(--csstools-color-scheme--light) var(--color-black-alpha-75);
      background-color: var(--csstools-light-dark-toggle-177de763-0, var(--color-white-alpha-75));
      -webkit-backdrop-filter: blur(3px);
              backdrop-filter: blur(3px);
    }

@supports (color: light-dark(red, red)) {
dialog::backdrop {
      background-color: light-dark(
        var(--color-white-alpha-75),
        var(--color-black-alpha-75)
      );
    }
}
  }

@media (width <= 1044px) {

dialog {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;

    margin: 0;

    font-size: var(--font-size-normal);
}
  }

dialog[open] {
    display: flex;
    flex-direction: column;
  }

progress {
  flex-shrink: 0;
  margin: 0 1rem 0.5rem;
}

@media (width <= 1044px) {

progress {
    margin-inline: 0.3rem;
}
  }

.header {
  display: flex;

  flex-shrink: 0;

  align-items: center;

  height: var(--navigation-height);
}

.close {
  font-size: 1.37rem;
}

@media (width > 1044px) {

.close {
    display: none;
}
  }

form {
  display: grid;

  flex: 1;

  grid-template-columns: min-content 1fr;

  gap: 0.5rem;
  place-items: center;

  padding: 1rem;
}

@media (width <= 1044px) {

form {
    align-self: center;

    padding: 0.5rem;
    margin-left: 0.3rem;

    background-color: var(--color-background-primary);
    border: 1px solid var(--color-border-primary);
    border-radius: 0.5rem;
}
  }

form::before {
    width: 1em;
    height: 1em;

    content: "";

    background-color: var(--color-border-secondary);

    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mask-size: contain;
  }

input {
  width: 100%;

  padding: 0;
  margin: 0;

  font-size: inherit;

  outline: none;

  background-color: transparent;
  border: none;
}

input::placeholder {
    color: var(--color-text-secondary);
  }

ul {
  padding: 0;
  margin: 0;
  overflow: auto;
}

ul:has(li) {
    border-top: 1px solid var(--color-border-primary);
  }

li[data-selected] {
  background: var(--color-background-blue);
  border-color: var(--color-blue-50);
}

li {
  list-style-type: none;
  border-inline-start: 2px solid transparent;
}

li:not([data-selected]):hover {
    background-color: var(--color-background-secondary);
  }

li > * {
  width: 100%;
  padding: 0.5rem 1.5rem;
}

a {
  display: grid;
  color: var(--color-link-normal);
  -webkit-text-decoration: none;
  text-decoration: none;
}

a:visited {
    color: var(--color-link-visited);
  }

.slug {
  font-size: var(--font-size-small);
  color: var(--color-text-secondary);
}

mark {
  color: var(--color-text-primary);
  background-color: var(--color-background-yellow);
}
`, "",{"version":3,"sources":["webpack://./components/search-modal/element.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,SAAS;AACX;;AAEA;;AAEA;IACI,6CAA6C;IAC7C,2DAA2D;;IAE3D,0DAA0D;;IAE1D,iCAAiC;;IAEjC,iDAAiD;IACjD,6CAA6C;IAC7C,qBAAqB;AACzB;;IAEI;MACE,wGAAwG;MACxG,2FAA2F;MAC3F,kCAAkC;cAC1B,0BAA0B;IACpC;;AAEJ;AACA;MACM;;;OAGC;IACH;AACJ;EACE;;AAEF;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;;IAEhB,SAAS;;IAET,kCAAkC;AACtC;EACE;;AAEF;IACI,aAAa;IACb,sBAAsB;EACxB;;AAEF;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;AAEA;IACI,qBAAqB;AACzB;EACE;;AAEF;EACE,aAAa;;EAEb,cAAc;;EAEd,mBAAmB;;EAEnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;AAEA;IACI,aAAa;AACjB;EACE;;AAEF;EACE,aAAa;;EAEb,OAAO;;EAEP,sCAAsC;;EAEtC,WAAW;EACX,mBAAmB;;EAEnB,aAAa;AACf;;AAEA;;AAEA;IACI,kBAAkB;;IAElB,eAAe;IACf,mBAAmB;;IAEnB,iDAAiD;IACjD,6CAA6C;IAC7C,qBAAqB;AACzB;EACE;;AAEF;IACI,UAAU;IACV,WAAW;;IAEX,WAAW;;IAEX,+CAA+C;;IAE/C,mDAAqC;IACrC,kBAAkB;EACpB;;AAEF;EACE,WAAW;;EAEX,UAAU;EACV,SAAS;;EAET,kBAAkB;;EAElB,aAAa;;EAEb,6BAA6B;EAC7B,YAAY;AACd;;AAEA;IACI,kCAAkC;EACpC;;AAEF;EACE,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;IACI,iDAAiD;EACnD;;AAEF;EACE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;IACI,mDAAmD;EACrD;;AAEF;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;IACI,gCAAgC;EAClC;;AAEF;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;AAClD","sourcesContent":["*,\n::before,\n::after {\n  box-sizing: border-box;\n}\n\ndialog {\n  padding: 0;\n  overscroll-behavior: contain;\n  border: 0;\n}\n\n@media (width > 1044px) {\n\ndialog {\n    width: calc(var(--layout-content-max) + 1rem);\n    max-height: calc(100% - var(--sticky-header-height) - 2rem);\n\n    margin: calc(var(--sticky-header-height) + 1rem) auto 1rem;\n\n    font-size: var(--font-size-large);\n\n    background-color: var(--color-background-primary);\n    border: 1px solid var(--color-border-primary);\n    border-radius: 0.5rem;\n}\n\n    dialog::backdrop {\n      --csstools-light-dark-toggle-177de763-0: var(--csstools-color-scheme--light) var(--color-black-alpha-75);\n      background-color: var(--csstools-light-dark-toggle-177de763-0, var(--color-white-alpha-75));\n      -webkit-backdrop-filter: blur(3px);\n              backdrop-filter: blur(3px);\n    }\n\n@supports (color: light-dark(red, red)) {\ndialog::backdrop {\n      background-color: light-dark(\n        var(--color-white-alpha-75),\n        var(--color-black-alpha-75)\n      );\n    }\n}\n  }\n\n@media (width <= 1044px) {\n\ndialog {\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: 100%;\n\n    margin: 0;\n\n    font-size: var(--font-size-normal);\n}\n  }\n\ndialog[open] {\n    display: flex;\n    flex-direction: column;\n  }\n\nprogress {\n  flex-shrink: 0;\n  margin: 0 1rem 0.5rem;\n}\n\n@media (width <= 1044px) {\n\nprogress {\n    margin-inline: 0.3rem;\n}\n  }\n\n.header {\n  display: flex;\n\n  flex-shrink: 0;\n\n  align-items: center;\n\n  height: var(--navigation-height);\n}\n\n.close {\n  font-size: 1.37rem;\n}\n\n@media (width > 1044px) {\n\n.close {\n    display: none;\n}\n  }\n\nform {\n  display: grid;\n\n  flex: 1;\n\n  grid-template-columns: min-content 1fr;\n\n  gap: 0.5rem;\n  place-items: center;\n\n  padding: 1rem;\n}\n\n@media (width <= 1044px) {\n\nform {\n    align-self: center;\n\n    padding: 0.5rem;\n    margin-left: 0.3rem;\n\n    background-color: var(--color-background-primary);\n    border: 1px solid var(--color-border-primary);\n    border-radius: 0.5rem;\n}\n  }\n\nform::before {\n    width: 1em;\n    height: 1em;\n\n    content: \"\";\n\n    background-color: var(--color-border-secondary);\n\n    mask-image: url(\"../icon/search.svg\");\n    mask-size: contain;\n  }\n\ninput {\n  width: 100%;\n\n  padding: 0;\n  margin: 0;\n\n  font-size: inherit;\n\n  outline: none;\n\n  background-color: transparent;\n  border: none;\n}\n\ninput::placeholder {\n    color: var(--color-text-secondary);\n  }\n\nul {\n  padding: 0;\n  margin: 0;\n  overflow: auto;\n}\n\nul:has(li) {\n    border-top: 1px solid var(--color-border-primary);\n  }\n\nli[data-selected] {\n  background: var(--color-background-blue);\n  border-color: var(--color-blue-50);\n}\n\nli {\n  list-style-type: none;\n  border-inline-start: 2px solid transparent;\n}\n\nli:not([data-selected]):hover {\n    background-color: var(--color-background-secondary);\n  }\n\nli > * {\n  width: 100%;\n  padding: 0.5rem 1.5rem;\n}\n\na {\n  display: grid;\n  color: var(--color-link-normal);\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\na:visited {\n    color: var(--color-link-visited);\n  }\n\n.slug {\n  font-size: var(--font-size-small);\n  color: var(--color-text-secondary);\n}\n\nmark {\n  color: var(--color-text-primary);\n  background-color: var(--color-background-yellow);\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
